import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforschooltripinpune() {



  const cardData =
  {
    keyword: 'Bus Hire for School Trips in Pune ',
    heading: 'Sanavi Travels: Bus Hire for School Trips in Pune',
    headingDescription: 'Sanavi Travels offers reliable Bus Hire for School Trips in Pune, providing safe, comfortable, and well-managed transportation solutions for schools, colleges, educational institutions, and training centers. Our fleet of well-maintained 20, 25, 30, 32, 35, 40, 45, and 50 seater buses is ideal for school picnics, educational tours, field trips, sports events, and interschool competitions, ensuring spacious seating, air-conditioned comfort, and adequate luggage space. With experienced, licensed, and background-verified chauffeurs trained in student safety protocols, flexible one-day and multi-day hire options, transparent pricing, and 24/7 coordination support, Sanavi Travels ensures a safe and smooth travel experience for students and staff. From pickup at school premises across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Airport Road areas—to destinations such as Lonavala, Sinhagad, Mahabaleshwar, Shirdi, and other educational or picnic locations, Sanavi Travels provides trusted bus hire services for school trips in Pune, focusing on safety, punctuality, and dependable group transportation.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage, valor, and architectural brilliance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum showcasing Gandhi’s personal artifacts, photographs, and historical documents. The palace’s sprawling gardens, Italian arches, and serene ambiance make it a peaceful retreat. The site also houses the samadhis of Kasturba Gandhi and Mahadev Desai, making it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations with music, decorations, and cultural events. The trust behind the temple is also known for extensive charitable work. Devotees find immense peace, blessings, and spiritual solace here. Dagdusheth Ganpati remains the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges, dotted with lush greenery. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature, attracting both historians and thrill-seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being located in a busy urban area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase the mastery of early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat, offering peace, meditation, and a connection with the city’s ancient past."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes traditional ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal is a major attraction, depicting the lifestyle of historical India. The museum serves as a living archive of art, craftsmanship, and history, making it an invaluable destination for art lovers, students, and tourists seeking cultural insights."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point, attracting devotees, history enthusiasts, and nature lovers alike."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, rejuvenation, and personal transformation. Osho Ashram is Pune’s international retreat for tranquility, blending spiritual learning with holistic wellness practices."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families, joggers, and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, offering a serene sanctuary within Pune’s urban landscape. It is an ideal spot for relaxation, picnics, and reconnecting with nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during the monsoon season. Street vendors selling roasted corn, tea, and local snacks add to its charm. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends, sunset views, and family outings, offering both natural beauty and recreational opportunities."
  }
]
,





"services": [
    {
      "name": "Bus Hire for School Trips in Pune",
      "description": "Bus Hire for School Trips in Pune provides reliable and spacious buses specifically for school trips, excursions, and educational tours. Vehicles are well-maintained, equipped with safety features, and ideal for transporting large groups of students comfortably. Professional drivers ensure punctual, safe, and smooth travel for school outings, field trips, or inter-school events."
    },
    {
      "name": "School Bus Rental Pune",
      "description": "School Bus Rental Pune offers flexible rental options for school trips, picnics, and extracurricular activities. Buses feature ample seating, luggage space, and child-friendly interiors. Experienced chauffeurs ensure safe and timely journeys, allowing students and teachers to focus on activities without travel stress."
    },
    {
      "name": "AC School Bus Pune",
      "description": "AC School Bus Pune provides air-conditioned buses for comfortable student travel, even during hot weather. Spacious seating, safe interiors, and professional drivers make it ideal for day trips, long-distance educational tours, and school events, ensuring a pleasant and safe journey for students."
    },
    {
      "name": "School Picnic Bus Hire Pune",
      "description": "School Picnic Bus Hire Pune offers convenient transportation for school picnics and day outings. Buses are spacious, well-maintained, and equipped for comfort, safety, and easy luggage management. Skilled drivers ensure a smooth and punctual journey, making school excursions stress-free for teachers and students."
    },
    {
      "name": "Affordable School Bus Pune",
      "description": "Affordable School Bus Pune provides budget-friendly bus rental services for school trips without compromising safety or comfort. Well-maintained buses, professional drivers, and ample seating ensure a reliable and economical solution for school excursions, educational tours, and day trips."
    },
    {
      "name": "Safe School Bus Hire Pune",
      "description": "Safe School Bus Hire Pune emphasizes student safety with well-equipped buses, seat belts, and trained drivers. Ideal for school outings, picnics, and field trips, these buses ensure secure and comfortable travel for children, along with timely arrivals and smooth journeys."
    },
    {
      "name": "School Excursion Bus Pune",
      "description": "School Excursion Bus Pune caters to educational trips, excursions, and inter-school events. Buses provide ample seating, luggage space, and safety features. Experienced chauffeurs manage routes efficiently, ensuring students travel comfortably and safely to their destinations."
    },
    {
      "name": "Educational Trip Bus Pune",
      "description": "Educational Trip Bus Pune offers buses for inter-school tours, educational visits, and field trips. Vehicles are spacious, well-maintained, and equipped with modern amenities. Skilled drivers ensure safety, punctuality, and smooth travel for students and accompanying teachers."
    },
    {
      "name": "Chauffeur Driven School Bus",
      "description": "Chauffeur Driven School Bus provides professional drivers for hassle-free and safe school travel. Drivers handle routes efficiently, ensuring timely pick-ups and drop-offs. Spacious and comfortable buses allow students to relax and enjoy their journey."
    },
    {
      "name": "Group Travel School Bus Pune",
      "description": "Group Travel School Bus Pune caters to large groups of students traveling together for excursions, educational tours, or inter-school events. Buses are comfortable, spacious, and maintained for safety. Professional drivers ensure a reliable and smooth journey for large student groups."
    },
    {
      "name": "Best School Bus Service Pune",
      "description": "Best School Bus Service Pune offers top-quality buses, well-maintained interiors, safety features, and professional drivers. Ideal for school trips, picnics, and educational tours, this service prioritizes comfort, reliability, and student safety throughout the journey."
    },
    {
      "name": "Pune School Bus Booking",
      "description": "Pune School Bus Booking provides easy online and offline booking for school buses. Flexible schedules, transparent pricing, and reliable vehicles ensure convenient and stress-free planning for school trips, excursions, and educational tours."
    },
    {
      "name": "Student Tour Bus Pune",
      "description": "Student Tour Bus Pune offers dependable buses for student tours, excursions, and long-distance educational trips. Buses feature spacious seating, safety equipment, and professional chauffeurs for a smooth, secure, and comfortable journey for students and teachers."
    },
    {
      "name": "School Event Bus Pune",
      "description": "School Event Bus Pune provides reliable buses for school events, inter-school competitions, and extracurricular activities. Comfortable seating, safety features, and professional drivers ensure smooth transport for students and staff attending events within and outside Pune."
    },
    {
      "name": "Local School Bus Pune",
      "description": "Local School Bus Pune offers buses for daily school transportation, local trips, and short-distance educational activities. Buses are safe, spacious, and chauffeur-driven, providing reliable and comfortable travel for students in Pune and surrounding areas."
    }
  ],
  "tableData": [
    ["Bus Hire for School Trips in Pune", "School Bus Rental Pune"],
    ["AC School Bus Pune", "School Picnic Bus Hire Pune"],
    ["Affordable School Bus Pune", "Safe School Bus Hire Pune"],
    ["School Excursion Bus Pune", "Educational Trip Bus Pune"],
    ["Chauffeur Driven School Bus", "Group Travel School Bus Pune"],
    ["Best School Bus Service Pune", "Pune School Bus Booking"],
    ["Student Tour Bus Pune", "School Event Bus Pune"],
    ["Local School Bus Pune", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire for School Trips in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers safe and reliable bus hire services for school trips in Pune, perfect for educational tours, excursions, and inter-school events."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Buses",
    "WhyChoosedescription": "Travel in air-conditioned, well-maintained buses with comfortable seating, ensuring a safe and enjoyable journey for students and staff."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune Routes",
    "WhyChoosedescription": "Our professional drivers are knowledgeable about Pune city and surrounding areas, providing punctual, secure, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear, upfront pricing for school trip bus hire, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel inquiries, and last-minute changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from half-day, full-day, or customized rental plans according to your school trip requirements in Pune."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure student safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for school bus hire in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services for school trips in Pune?',
    answer: 'Yes, Sanavi Travels offers safe and comfortable buses for school trips, ensuring a smooth and enjoyable journey for students and staff.'
  },
  {
    question: 'How can I book a bus for a school trip in Pune with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for school trips?',
    answer: 'We provide a range of buses including mini, medium, and large capacity buses suitable for school groups of any size.'
  },
  {
    question: 'Are drivers included in the school trip bus rental?',
    answer: 'Yes, all bus rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the school trip bus hire service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel.'
  },
  {
    question: 'Are the buses sanitized before trips?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the bus rental plan for a school trip?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your school trip needs.'
  },
  {
    question: 'What payment options are available for school bus hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the school trip?',
    answer: 'Yes, our 24x7 customer support team is available throughout your journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Deshmukh',
    feedback: 'Booked a bus for our school trip through Sanavi Travels. The bus was safe, clean, and the driver very professional. Students enjoyed the ride!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Excellent service for our school excursion. Buses were comfortable, timely, and safe. Highly recommend Sanavi Travels for school trips.',
    rating: 5
  }
];































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for School Trips in Pune - Sanavi Travels",
  "description": "Bus hire for school trips in Pune by Sanavi Travels for educational tours, school picnics, excursions, and student events. Choose AC and luxury buses for safe, comfortable, and affordable travel for students and school groups.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1985"
  }
};









  return (
    <div>
<Helmet>
  <title>
    Bus Hire for School Trips in Pune Starting from ₹28 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus hire for school trips in Pune with Sanavi Travels. AC and luxury buses for educational tours, school picnics, excursions, and student group travel at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforschooltripinpune;